import React from 'react';
import { Icon } from 'view/atoms/Icon';
import * as S from './CategoriesItem.styles';

type Props = {
  text: string;
  icon: string;
  onClick: () => void;
  active: boolean;
  'data-testid'?: string;
};

export const CategoriesItem = ({
  active,
  text,
  icon,
  onClick,
  ...props
}: Props) => {
  return (
    <S.CategoriesItemStyles
      onClick={onClick}
      active={active}
      className='safe-to-click'
      {...props}
    >
      <Icon src={icon} />
      <S.TitleStyled>{text}</S.TitleStyled>
    </S.CategoriesItemStyles>
  );
};
